import { render, staticRenderFns } from "./Zbhxr.vue?vue&type=template&id=0623ffa6&scoped=true"
import script from "./Zbhxr.vue?vue&type=script&lang=js"
export * from "./Zbhxr.vue?vue&type=script&lang=js"
import style0 from "./Zbhxr.vue?vue&type=style&index=0&id=0623ffa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0623ffa6",
  null
  
)

export default component.exports